// src/contexts/DentallyLeadContext.jsx
//
// Shares the lead-detail route's Dentally integration scope and the single
// practice/lead-scoped patient-link lookup with descendants (hero chips,
// Personal details section). A context is used rather than props because the
// Personal details step element is captured once in `useState(STEPS)`, so
// props passed to it would be frozen at their initial (loading) values.
import { createContext, useContext } from 'react';

const DentallyLeadContext = createContext(null);

export const DentallyLeadProvider = DentallyLeadContext.Provider;

/** { scope, patientLink } from the nearest lead-detail body, or null outside it. */
export const useDentallyLeadContext = () => useContext(DentallyLeadContext);

export default DentallyLeadContext;
